var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-layout"},[_c('Sidebar'),_c('Navbar'),_c('div',{staticClass:"admin-content flex flex-col"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }